import RoutesWrapper from "@components/primitives/routesWrapper/RoutesWrapper";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Route } from "react-router-dom";
import AppContextProvider from "@components/features/appContext/AppContext";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "@components/pages/homePage/HomePage";
import { appPath } from "@routes/app";
import MembersPage from "@components/pages/membersPage/MembersPage";
import EventsPage from "@components/pages/eventsPage/EventsPage";
import ContactPage from "@components/pages/contactPage/ContactPage";
import PhotosPage from "@components/pages/photosPage/PhotosPage";
import MemberInformationPage from "@components/pages/memberInformationPage/MemberInformationPage";
import PrivacyPage from "@components/pages/privacyPage/PrivacyPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <AppContextProvider>
        <BrowserRouter>
          <RoutesWrapper>
            <Route path={appPath.default} element={<HomePage />} />
            <Route path={appPath.members} element={<MembersPage />} />
            <Route path={appPath.member} element={<MemberInformationPage />} />
            <Route path={appPath.events} element={<EventsPage />} />
            <Route path={appPath.photos} element={<PhotosPage />} />
            <Route path={appPath.contact} element={<ContactPage />} />
            <Route path={appPath.privacy} element={<PrivacyPage />} />
          </RoutesWrapper>
        </BrowserRouter>
      </AppContextProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
